module.exports = __webpack_public_path__ + "static/media/brooklyn_brewery.570cd310.svg";